import renderer from 'react-test-renderer';

export const snapshot = (component: JSX.Element): void => {
	const tree = renderer.create(component).toJSON();
	expect(tree).toMatchSnapshot();
};
